import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FiSearch, FiDownload } from 'react-icons/fi';
import reportesAvanzadosService from '../services/reportesAvanzadosService';
import Loading from '../components/Loading';
import './BalanceComprobacionPage.css';

const BalanceComprobacionPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [nivel, setNivel] = useState('');

  const cargar = async () => {
    try {
      setLoading(true);
      const filters = {};
      if (fechaDesde) filters.fecha_desde = fechaDesde;
      if (fechaHasta) filters.fecha_hasta = fechaHasta;
      if (nivel) filters.nivel = nivel;
      const res = await reportesAvanzadosService.getBalanceComprobacion(filters);
      setData(res.data);
    } catch { toast.error('Error al cargar balance de comprobacion'); }
    finally { setLoading(false); }
  };

  const formatCurrency = (v) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(v || 0);

  const exportarExcel = async () => {
    try {
      const XLSX = (await import('xlsx')).default;
      const cuentas = data?.cuentas || [];
      const ws = XLSX.utils.json_to_sheet(cuentas.map(c => ({
        Codigo: c.codigo, Nombre: c.nombre, 'Suma Debe': c.suma_debe, 'Suma Haber': c.suma_haber,
        'Saldo Deudor': c.saldo_deudor, 'Saldo Acreedor': c.saldo_acreedor,
      })));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Balance Comprobacion');
      XLSX.writeFile(wb, `balance_comprobacion.xlsx`);
    } catch { toast.error('Error al exportar'); }
  };

  const cuentas = data?.cuentas || data?.results || [];
  const totales = data?.totales || {};

  return (
    <div className="balance-comp-page">
      <div className="page-header"><h1>Balance de Comprobacion</h1></div>

      <div className="selector-bar">
        <div className="form-group">
          <label>Desde</label>
          <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Hasta</label>
          <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Nivel</label>
          <select value={nivel} onChange={e => setNivel(e.target.value)}>
            <option value="">Todos</option>
            <option value="1">Nivel 1</option>
            <option value="2">Nivel 2</option>
            <option value="3">Nivel 3</option>
            <option value="4">Nivel 4</option>
            <option value="5">Nivel 5</option>
          </select>
        </div>
        <button className="btn-primary" onClick={cargar}><FiSearch /> Consultar</button>
        {data && <button className="btn-export" onClick={exportarExcel}><FiDownload /> Excel</button>}
      </div>

      {loading && <Loading />}

      {!loading && data && (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Codigo</th>
                <th>Cuenta</th>
                <th style={{ textAlign: 'right' }}>Suma Debe</th>
                <th style={{ textAlign: 'right' }}>Suma Haber</th>
                <th style={{ textAlign: 'right' }}>Saldo Deudor</th>
                <th style={{ textAlign: 'right' }}>Saldo Acreedor</th>
              </tr>
            </thead>
            <tbody>
              {cuentas.length === 0 ? (
                <tr><td colSpan="6" style={{ textAlign: 'center', padding: 40, color: '#6b7280' }}>Sin datos</td></tr>
              ) : cuentas.map((c, i) => (
                <tr key={i} className={c.nivel <= 2 ? 'row-bold' : ''}>
                  <td className="mono">{c.codigo}</td>
                  <td style={{ paddingLeft: `${(c.nivel - 1) * 16 + 16}px` }}>{c.nombre}</td>
                  <td className="mono right">{parseFloat(c.suma_debe) ? formatCurrency(c.suma_debe) : ''}</td>
                  <td className="mono right">{parseFloat(c.suma_haber) ? formatCurrency(c.suma_haber) : ''}</td>
                  <td className="mono right" style={{ color: '#dc2626' }}>{parseFloat(c.saldo_deudor) ? formatCurrency(c.saldo_deudor) : ''}</td>
                  <td className="mono right" style={{ color: '#059669' }}>{parseFloat(c.saldo_acreedor) ? formatCurrency(c.saldo_acreedor) : ''}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2" style={{ textAlign: 'right', fontWeight: 700 }}>TOTALES</td>
                <td className="mono right bold">{formatCurrency(totales.suma_debe || cuentas.reduce((s, c) => s + parseFloat(c.suma_debe || 0), 0))}</td>
                <td className="mono right bold">{formatCurrency(totales.suma_haber || cuentas.reduce((s, c) => s + parseFloat(c.suma_haber || 0), 0))}</td>
                <td className="mono right bold" style={{ color: '#dc2626' }}>{formatCurrency(totales.saldo_deudor || cuentas.reduce((s, c) => s + parseFloat(c.saldo_deudor || 0), 0))}</td>
                <td className="mono right bold" style={{ color: '#059669' }}>{formatCurrency(totales.saldo_acreedor || cuentas.reduce((s, c) => s + parseFloat(c.saldo_acreedor || 0), 0))}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
};

export default BalanceComprobacionPage;
